import { FC } from 'react';
import OverallStatusPage from '../../sharedComponents/overallStatusPage/OverallStatusPage';
import { useSelector } from 'react-redux';
import { activeDateSelector } from '../../../../redux/pages/selectors';

const SupplementaryRulesOverview: FC = () => {
  const activeDate = useSelector(activeDateSelector);

  return (
    <OverallStatusPage
      overviewDataPageKey="Supplementary_Rules"
      positionDate={activeDate || undefined}
    />
  );
};

export default SupplementaryRulesOverview;
